import { render, staticRenderFns } from "./RegisterSupplier.vue?vue&type=template&id=1bc6e07c&scoped=true&"
import script from "./RegisterSupplier.vue?vue&type=script&lang=js&"
export * from "./RegisterSupplier.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSupplier.vue?vue&type=style&index=0&id=1bc6e07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc6e07c",
  null
  
)

export default component.exports